module.exports = __webpack_public_path__ + "img/first-avater-2.c4fc8fb.png";